import { storyblokEditable } from "@storyblok/react";
import { useState, useEffect } from "react";

const ProductSlider = ({ blok }) => {
  return (
    <div
      className="productslider-overflowcontent flex"
      {...storyblokEditable(blok)}
      style={{ display: `${blok.none}`}}
    >
      <div id="productContent" className="product-content flex flex-col p-2">
        <div className="flex flex-col items-center">
          <div className="product-images flex py-4">
            {/*   <img src="/src/HP_MuenchnerRadler_Gloriabecher_rgb.png" alt="" />
            <img src="/src/hp_MUENCHNER_RADLER_2021_NEW_EMBOSS_1.png" alt=""/> */}
            <img src={blok.brand_image.filename} alt={blok.brand_image.alt} />
          </div>
          <span className="productslider-brand-product text-xl pb-2">
            {blok.brand_product}
          </span>
          <p className="productslider-brand-infotext scrollable">
            {blok.brand_info}
          </p>
        </div>
        <div className="product-footer items-center flex flex-col">
          <span className={`text-up ${!blok.brand_extract && "white-text"}`}>
            Stammwürze: {blok.brand_extract} °P
          </span>
          <span className={`text-up ${!blok.brand_alcohol && "white-text"}`}>
            Alkohol: {blok.brand_alcohol} %
          </span>
          <p className={`${!blok.brand_energy && "white-text"}`}>
            Energie pro 100ml: {blok.brand_energy}
          </p>
          {blok.note && <span className="productslider-note">{blok.note}</span>}
          <div className="product-bundle flex">
            <div className="pt-6 flex">
              {blok.brand_bundle1.filename && (
                <div className="flex flex-col justify-center items-center">
                  <div className="productslider-footer--container flex">
                    <span className="m-2">{blok.brand_size1}</span>
                    <p className="mt-2">{blok.brand_seperate1}</p>
                  </div>
                  <img
                    src={blok.brand_bundle1.filename}
                    alt={blok.brand_bundle1.alt}
                  />
                </div>
              )}

              {blok.brand_bundle2.filename && (
                <div className="flex flex-col justify-center items-center">
                  <div className="productslider-footer--container flex">
                    <span className="m-2">{blok.brand_size2}</span>
                    <p className="mt-2">{blok.brand_seperate2}</p>
                  </div>
                  <img
                    src={blok.brand_bundle2.filename}
                    alt={blok.brand_bundle2.alt}
                  />
                </div>
              )}

              {blok.brand_bundle3.filename && (
                <div className="flex flex-col justify-center items-center">
                  <div className="productslider-footer--container flex">
                    <span className="m-2">{blok.brand_size3}</span>
                    <p className="mt-2">{blok.brand_seperate3}</p>
                  </div>
                  <img
                    src={blok.brand_bundle3.filename}
                    alt={blok.brand_bundle3.alt}
                  />
                </div>
              )}

              {blok.brand_bundle4.filename && (
                <div className="flex flex-col justify-center items-center">
                  <div className="productslider-footer--container flex">
                    <span className="m-2">{blok.brand_size4}</span>
                    <p className="last-p mt-2">{blok.brand_seperate4}</p>
                  </div>
                  <img
                    src={blok.brand_bundle4.filename}
                    alt={blok.brand_bundle4.alt}
                  />
                </div>
              )}

              {blok.brand_bundle5 && blok.brand_bundle5.filename && (
                <div className="flex flex-col justify-center items-center">
                  <div className="productslider-footer--container flex">
                    <span className="m-2">{blok.brand_size5}</span>
                    <p className="last-p mt-2">{blok.brand_seperate5}</p>
                  </div>
                  <img
                    src={blok.brand_bundle5.filename}
                    alt={blok.brand_bundle5.alt}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="product-border-right"></div>
      </div>
    </div>
  );
};

export default ProductSlider;
